import {ChangeDetectorRef, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ELocalStorage} from '../../../enums/ELocalStorage';
import {NavigationService} from '../../../service/navigation.service';
import {UserService} from '../../../service/user.service';
import {AuthService} from '../../../service/auth.service';
import {IUser, IUser_P} from '../../../interfaces/IUser';
import {environment} from '../../../../environments/environment';
import {NotificationService} from '../../../service/notification.service';
import {Router} from "@angular/router";
import {UtilsService} from "../../../service/utils.service";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styles: [`
        :host ::ng-deep .pi-eye,
        :host ::ng-deep .pi-eye-slash {
            transform: scale(1.6);
            margin-right: 1rem;
            color: var(--primary-color) !important;
        }
    `],
    encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit {
    loading = {form: false};
    form: FormGroup | any;
    visible: boolean = false;
    visibleTC: boolean = false;

    constructor(private fb: FormBuilder,
                public userS: UserService,
                public router: Router,
                public cd: ChangeDetectorRef,
                public navigationService: NavigationService,
                public ns: NotificationService,
                public utilsService: UtilsService,
                public authService: AuthService) {
    }

    async ngOnInit() {
        this.createForm();
        let defaultAMToken: any = await this.userS.getAMToken();
        window.localStorage.setItem(ELocalStorage.DEFAULT_AM_AUTH, defaultAMToken.token);
    }

    createForm() {
        this.form = this.fb.group(<IUser_P>{
            usr_email_str: <any>['', [Validators.required, Validators.email]],
            usr_pin_str: <any>[''],
            pin1: ['', Validators.required],
            pin2: ['', Validators.required],
            pin3: ['', Validators.required],
            pin4: ['', Validators.required],
            pin5: ['', Validators.required],
            pin6: ['', Validators.required],
        });
    }

    async login() {
        console.log('Login called');
        let userPin: any = '';
        for (let pin of this.utilsService.userPin) {
            userPin = userPin + pin.value;
        }
        if (userPin.length < 6) return;
        const formData: IUser = this.form.getRawValue();
        formData.usr_pin_str = userPin;
        if (this.form.invalid) return;
        this.loading.form = true;
        setTimeout(async () => {
            try {
                const user: IUser | any = await this.userS.login(formData.usr_email_str.toLowerCase(), formData.usr_pin_str.toString());
                if (user === null || user === '' || user === '') {
                    this.loading.form = false;
                    return;
                }
                if (user?.accessToken) {
                    this.ns.showSuccess('Login Success.');
                    this.authService.token.accessToken = user.accessToken;
                    this.authService.token.refreshToken = user.refreshToken;
                    this.authService.setUserToLocalStorage(user, environment.crypto.passJWT);
                    await this.navigationService.gotoDashboard(this.authService.gUser);
                } else {
                    this.ns.showErrorFromResponse(user, 'Invalid credential.');
                }
                this.loading.form = false;
            } catch (e) {
                this.loading.form = false;
                this.ns.showErrorFromResponse(e.error || e, 'Invalid credential.');
            }
            this.loading.form = false;
            this.cd.detectChanges();
        }, 300);
        this.cd.detectChanges();
    }
}
